<template>
  <div class="card">
    <div class="card-top">
      <div class="card-title">
        <a
          class="collapsed d-block"
          data-toggle="collapse"
          :href="'#user' + user.id"
          aria-expanded="true"
          :aria-controls="'user' + user.id"
          id="heading-collapsed"
          style="padding-top: 7px; padding-left: 7px; padding-right: 7px"
        >
          <i
            v-if="isCollapsible"
            class="material-icons fa fa-chevron-down pull-right"
          >
            keyboard_arrow_down
          </i>
        </a>
        <router-link
          tag="div"
          class="cursor-pointer"
          :to="'/view-user/' + user.uuid_id"
        >
          {{ user.first_name }} {{ user.last_name }}
        </router-link>
      </div>
    </div>
    <div
      v-if="isCollapsible"
      :id="'user' + user.id"
      class="collapse"
      aria-labelledby="heading-collapsed"
    >
      <div class="card-body">
        <div class="d-flex flex-column profile-stats my-3">
          <div v-if="user.organisation" class="d-flex align-items-center">
            <i class="material-icons text-secondary">business</i>
            <em>Organisation:&nbsp;</em>
            <span class="element-label">
              <em>{{ user.organisation.name }}</em>
            </span>
          </div>
          <div v-if="user.organisation" class="d-flex align-items-center">
            <i class="material-icons text-secondary">web</i>
            <em>Website:&nbsp;</em>
            <a v-bind:href="user.organisation.website">
              <span class="element-label">
                <em>{{ user.organisation.website }}</em>
              </span>
            </a>
          </div>
        </div>
        <div v-if="includeActions === true" class="mb-2 action action-2">
          <button
            class="btn btn-primary w-100"
            @click="$emit('toggle-enabled')"
          >
            <span v-if="user.enabled">Disable</span>
            <span v-else>Enable</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "user-card",
  props: {
    user: Object,
    includeActions: Boolean,
  },
  computed: {
    isCollapsible() {
      return this.user.organisation || this.includeActions;
    },
  },
};
</script>

<style scoped>
.card-title {
  display: flex;
  flex-wrap: nowrap;
  line-height: 1.1;
  padding: 0;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  border-bottom: 0px solid rgba(0, 0, 0, 0);
}

.card-title > div {
  width: 30%;
  font-size: 18px;
  overflow: hidden;
  white-space: nowrap;
  margin: 10px;
}

.card-body {
  display: flex;
  flex-wrap: nowrap;
}

.card-body > div {
  width: 400px;
  overflow: hidden;
  margin: 0;
}

.card-top .fa {
  transition: 0.3s transform ease-in-out;
  padding: 0;
  margin-bottom: 0;
}

.card-top .collapsed .fa {
  transform: rotate(-90deg);
}
</style>
